export const copy = {
  brand: "툰트원",
  eyebrow: "한국어 카툰 색 맞히기 게임",
  title: "보이는 카툰 색을 슬라이더로 맞히는 색 게임",
  subtitle:
    "목표 색이 라운드 내내 화면에 떠 있는 동안 색상, 채도, 밝기를 조절해 가장 가까운 색을 만들어 보세요. 10라운드 동안 점수가 쌓입니다.",
  start: "게임 시작",
  newGame: "새 게임",
  next: "다음 라운드",
  nextRound: "다음 라운드 →",
  viewResults: "결과 보기 →",
  submit: "이 색으로 제출",
  share: "결과 공유",
  copyResult: "결과 복사",
  copied: "결과가 복사되었습니다.",
  copyFailed: "복사할 수 없어 결과를 직접 선택해 주세요.",
  target: "목표 색",
  guess: "내 선택",
  round: "라운드",
  total: "총점",
  average: "평균",
  hue: "색상",
  saturation: "채도",
  brightness: "밝기",
  complete: "10라운드 완료",
  promptSuffix: "와 같은 색을 만들어 보세요",
  scoreDistance: "색 차이",
  bestScore: "최고 점수",
  perRound: "라운드별 점수",
  introPrompt: "보이는 카툰 색을 슬라이더로 똑같이 맞춰 보세요",
  introCta: "게임을 시작하면 첫 번째 목표 색이 곧바로 나타납니다.",
  liveHint: "두 색이 같아 보일 때까지 슬라이더를 조절하세요. 색 코드는 보이지 않습니다.",
  lastRound: "지난 라운드",
  finalLabel: "최종 결과",
  reviewTitle: "라운드 결과",
  deltaLabel: "ΔE 색 차이",
  scoreLabelKo: "획득 점수",
  targetHsb: "목표 HSB",
  guessHsb: "내 HSB",
  point: "점",
  guideTitle: "플레이 방식",
  guideOne:
    "각 라운드는 카툰 캐릭터의 한 부분에 목표 색이 입혀져 있습니다. 색은 라운드가 끝날 때까지 그대로 보이므로 천천히 살펴보세요.",
  guideTwo:
    "세 개의 슬라이더로 색상, 채도, 밝기를 조절해 같은 색을 만듭니다. 색상은 어떤 계열인지, 채도는 얼마나 선명한지, 밝기는 얼마나 밝은지를 뜻합니다.",
  guideThree:
    "점수는 화면 픽셀의 단순 차이가 아니라 사람 눈에 가까운 지각 색 차이로 계산합니다. 한 라운드 최대 100점, 10라운드 총점은 1000점입니다.",
  qualityTitle: "이런 점이 다릅니다",
  qualityText:
    "회원 가입과 광고가 없습니다. 점수는 브라우저에만 저장되며, 매 게임마다 새 색 조합이 만들어집니다. 색 코드(HEX) 표기는 숨겨져 있어 눈으로 비교한 결과만 점수에 반영됩니다.",
  faqTitle: "자주 묻는 질문",
  faqItems: [
    {
      q: "툰트원은 어떤 게임인가요?",
      a: "카툰풍 원본 도형에 칠해진 목표 색을 보면서 색상, 채도, 밝기 슬라이더로 똑같이 맞히는 한국어 색 맞히기 게임입니다.",
    },
    {
      q: "목표 색은 라운드 중에 사라지나요?",
      a: "사라지지 않습니다. 목표 색은 라운드가 끝날 때까지 화면에 그대로 보입니다. 기억력이 아닌 색 감각을 측정합니다.",
    },
    {
      q: "점수는 어떻게 계산되나요?",
      a: "목표 색과 내 선택을 지각 색 공간(Lab)에서 비교해 색 차이가 작을수록 높은 점수를 줍니다. 라운드당 최대 100점, 총 1000점입니다.",
    },
    {
      q: "실제 애니메이션이나 만화 캐릭터를 사용하나요?",
      a: "아니요. 모든 시각 요소는 저작권 캐릭터를 쓰지 않는 원본 카툰 도형과 추상 색 조합으로 만들었습니다.",
    },
    {
      q: "설치나 회원 가입이 필요한가요?",
      a: "필요하지 않습니다. 휴대폰, 태블릿, 데스크톱 브라우저에서 바로 플레이할 수 있고 점수는 내 브라우저에만 저장됩니다.",
    },
  ],
} as const;
